import dayjs from "dayjs";

const scoreColor = (score, version) => {
  let rank = 'none';
  if (version >= 3) {
    if (score > 0.1 && score < 4.0) {
      rank = 'low';
    } else if (score > 3.9 && score < 7) {
      rank = 'medium';
    } else if (score > 6.9 && score < 9) {
      rank = 'high';
    } else if (score > 8.9 && score <= 10) {
      rank = 'critical';
    }
  } else if (version < 3) {
    if (score > 0 && score < 4.0) {
      rank = 'low';
    } else if (score > 3.9 && score < 7) {
      rank = 'medium';
    } else if (score > 6.9 && score <= 10) {
      rank = 'high';
    }
  }
  return rank;
};

const getCveFields = () => {
  return [
    'kevDescription',
    'kevVendorProject',
    'kevProduct',
    'kevRequiredAction',
    'kevDueDate',
    'kevKnownRansomwareCampaignUse',
    'kevNotes',
  ];
};

const hasFalsyValues = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  return Object.values(obj).some((value) => !value);
};

export { scoreColor, getCveFields, hasFalsyValues };

export const cleanFloat = (value, decimals = 2) => {
  if (value === null || value === undefined || value === "") return value;

  const num = Number(value);
  if (isNaN(num)) return value;

  return Number(num.toFixed(decimals));
};

export const getFieldByName = (fields, fieldName) => {
  return fields?.some(field => field.fieldName === fieldName) ?? false;
};

// Helper function for date formatting using dayjs
export const formatDate = (date, format = "YYYY-MM-DD") => {
  if (!date) return "";
  
  const d = dayjs(date);
  if (!d.isValid()) return "";

  return d.format(format);
};

// Additional helper functions for date operations
export const formatDateRange = (startDate, endDate, format = "YYYY-MM-DD") => {
  const formatted = {};
  
  if (startDate) {
    const start = dayjs(startDate);
    formatted.gte = start.isValid() ? start.format(format) : null;
  }
  
  if (endDate) {
    const end = dayjs(endDate);
    formatted.lte = end.isValid() ? end.format(format) : null;
  }
  
  return formatted;
};
